<script>
import {BFormCheckbox} from 'bootstrap-vue/src/components/form-checkbox/form-checkbox'

export default {
  extends: BFormCheckbox,
}
</script>

<style lang="scss">

@import "./index";
</style>
